export default __webpack_public_path__ + "static/media/slack2.df964dca.png";